
import axios from 'axios';

import { ActionType } from '../actionTypes';

import envManager from '../../com/envManager/EnvManager';

import { Action as FlippingFlyerActions} from '../actions/flippingFlyerActions';
import { Action as GuiSettingsActions} from '../actions/guiSettingsActions';

import { Dispatch } from 'redux';
import {UserDto, GuiSettingsDto, ErrorDtoFactory, FileDto} from '../../dtos';
import {FlyerDetailsState} from "../reducers/flyerDetailsReducer";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";

export const getGuiSettings = () => {

    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<GuiSettingsActions>) => {
        dispatch({ 
            type: ActionType.GET_GUI_SETTINGS_START 
        })

        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let result = await axios.get(`${envManager.flyerEditorServerAddress}/api/guithemes/${userDto.userId}`, config);
            let data = result.data.data;

            let guiSettings: GuiSettingsDto[] = [ ...data ]

            dispatch({
                type: ActionType.GET_GUI_SETTINGS_SUCCESS,
                payload: guiSettings
            })

            dispatch({
                type: ActionType.GET_GUI_SETTINGS_COMPLETED
            })
        } 
        catch(err){
            dispatch({
                type: ActionType.GET_GUI_SETTINGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const saveGuiSettings = (guiSettingDto: GuiSettingsDto, flyerDetailsState: FlyerDetailsState, backgroundFile:  FileDto | null, logoFile: FileDto | null,) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    // prepare files data
    const formData = new FormData(); 

    formData.append("guiSettingDto", JSON.stringify(guiSettingDto));

    if(logoFile && logoFile?.file){
        formData.append("logoImage", logoFile?.file!, logoFile!.label!);
    }
    if(backgroundFile && backgroundFile.file){
        formData.append("backgroundImage", backgroundFile?.file!, backgroundFile!.label!);
    }

    return async (dispatch: Dispatch<GuiSettingsActions | FlippingFlyerActions | FlyerDetailsActions>) => {
        dispatch({ 
            type: ActionType.PUT_GUI_SETTINGS_START 
        })

        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let url = `${envManager.flyerEditorServerAddress}/api/guithemes/${userDto.userId}`;
            let result = await axios.put(url, formData, config);
            let data = result.data.data;

            let guiSettingsDtos: GuiSettingsDto[] = [ ...data.guiSettingsDtos ]
            let currentGuiSettingsDto: GuiSettingsDto = { ...data.currentGuiSettingsDto }
            dispatch({
                type: ActionType.PUT_GUI_SETTINGS_SUCCESS,
                payload: {
                    guiSettingsDtos,
                    currentGuiSettingsDto
                }
            })

            dispatch({
                type: ActionType.PUT_GUI_SETTINGS_COMPLETED
            })

            // if the updated gui settings contain the one that is currently being viewed inside the
            // flyer editor, we must also update its values
            if(flyerDetailsState.flyGusRec) {
                
                let isNeedToUpdateFlyerState = false;

                for(let i = 0; i < guiSettingsDtos.length; i++)
                {
                    let dto = guiSettingsDtos[i];
                    if(dto.gusRecId === flyerDetailsState.flyGusRec.gusRecId) {
                        flyerDetailsState.flyGusRec = dto;
                        isNeedToUpdateFlyerState = true;
                        break;
                    }
                }
                 
                if(isNeedToUpdateFlyerState)
                {
                    var newFlyerState: FlyerDetailsState = {
                        ...flyerDetailsState,
                    }
                    dispatch({
                        type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                        payload: newFlyerState,
                    });
                }
            }
        } 
        catch(err){
            dispatch({
                type: ActionType.PUT_GUI_SETTINGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}


export const deleteGuiSettings = (guiSettingDto: GuiSettingsDto) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<GuiSettingsActions>) => {
        dispatch({ 
            type: ActionType.DELETE_GUI_SETTINGS_START 
        })

        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            let url = `${envManager.flyerEditorServerAddress}/api/guithemes/${guiSettingDto.gusRecId}`;
            let result = await axios.delete(url, config);
            let data = result.data.data;

            let guiSettings: GuiSettingsDto[] = [ ...data ]

            dispatch({
                type: ActionType.DELETE_GUI_SETTINGS_SUCCESS,
                payload: guiSettings
            })

            dispatch({
                type: ActionType.DELETE_GUI_SETTINGS_COMPLETED
            })
        } 
        catch(err){
            dispatch({
                type: ActionType.DELETE_GUI_SETTINGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}